export default {"src":"/_next/static/media/add-wishlist.84934cb5.svg","height":15,"width":15};